import { getCurrentInstance } from 'vue';

export enum AppPkgName {
    /**
     * @zh bomdia app
     */
    BOMDIA_APP = 'bom.dia.video.imagen.frases.download',
    /**
     * @zh weeeye app
     */
    AI_CHAT_APP = 'ai.questionai.chat.bot',
    /**
     * @zh Kwai Pro
     */
    KWAI_PRO_APP = 'com.kwai.video',
}

export const checkIfAppEnvironment = () => {
    const { proxy }: any = getCurrentInstance() || {};
    return proxy?.$isAppEnvironment;
};

export const checkIfBomdiaApp = () => {
    const { proxy }: any = getCurrentInstance() || {};
    return proxy?.$isAppEnvironment && proxy?.$appConfig?.pkg === AppPkgName.BOMDIA_APP;
};

export const checkIfAiChatApp = () => {
    const { proxy }: any = getCurrentInstance() || {};
    return proxy?.$isAppEnvironment && proxy?.$appConfig?.pkg === AppPkgName.AI_CHAT_APP;
};

export const checkIfIOSApp = () => {
    const { proxy }: any = getCurrentInstance() || {};
    return proxy?.$appConfig?.isIOS === 'true';
};

export const checkIfKwaiProApp = () => {
    const { proxy }: any = getCurrentInstance() || {};
    return proxy?.$isAppEnvironment && proxy?.$appConfig?.pkg === AppPkgName.KWAI_PRO_APP;
};
